<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-12 col-md-3 col-lg-3 col-xl-4 custom-width-desktop">
        <div class="scrollable-container">
          <div class="scrollable-div bg-light shadow-lg rounded-lg p-2">
            <div class="text-center">
              <h2>
                Der Kaffeemaschinen-Finder
                <img src="https://findingo.de/wp-content/uploads/2024/12/cropped-logo_small.png" class="img-fluid"
                  style="width: 20%;" alt="...">
              </h2>
                              <h4 class="h4 mt-2" style="font-family:Open Sans,Arial,sans-serif">
    Zu komplizierte Technik? Dann nutze die 
    <a href="https://findingo.de/kaffeemaschinen/kaffeemaschinen-kaufberatung/"
      style="font-size:1.3rem;color: #007bff; text-decoration: underline; position: relative">
      smarte Kaufberatung für jegliche Art von Kaffeemaschinen!</a>
    <span style="
        background-color: #ff3b30; 
        color: white; 
        font-weight: bold; 
        font-size: 0.7rem; 
        padding: 1px 5px; 
        border-radius: 6px; 
        position: relative; 
        top: -0.6em; 
        margin-left: 4px;
    ">NEW</span>
    aus!
  </h4>
            </div>
            <form method="GET" name="finder-form" id="finder-form" @change="onFormChange">
              <div class="formContent p-2">
                <div class="row row-cols-2">

                  <div class="ml-2 mb-3 w-[80%]">
                    <span
                      class="spanField small fw-semibold d-inline-block mt-1 py-1 px-2 text-uppercase text-black bg-cs-color">
                      Hersteller
                    </span>
                    <select v-model="filters.marke" id="marke" name="marke"
                      class="spanSelectField form-select form-select-lg mb-1">
                      <option value="Alle" selected>Alle</option>
                      <option value="Ariete">Ariete</option>
                      <option value="Bosch">Bosch</option>
                      <option value="Gaggia">Gaggia</option>
                      <option value="Grundig">Grundig</option>
                      <option value="KitchenAid">KitchenAid</option>
                      <option value="Krups">Krups</option>
                      <option value="Philips">Philips</option>
                      <option value="Saeco">Saeco</option>
                      <option value="Senseo">Senseo</option>
                      <option value="Siemens">Siemens</option>
                      <option value="Tefal">Tefal</option>
                      <option value="WMF">WMF</option>
                    </select>
                  </div>

                  <div class="ml-2 mb-3 w-[80%]">
                    <span
                      class="spanField small fw-semibold d-inline-block mt-1 py-1 px-2 text-uppercase text-black bg-cs-color">
                      Zubereitungstyp
                    </span>
                    <select v-model="filters.kaffeezubereitungstyp" id="kaffeezubereitungstyp"
                      name="kaffeezubereitungstyp" class="spanSelectField form-select form-select-lg mb-1">
                      <option value="Alle" selected>Alle</option>
                      <option value="Vollautomatisch">Vollautomatisch</option>
                      <option value="Halbautomatisch">Halbautomatisch</option>
                      <option value="Manuell">Manuell</option>

                    </select>
                  </div>

                  <div class="ml-2 mb-3 w-[80%]">
                    <span
                      class="spanField small fw-semibold d-inline-block mt-1 py-1 px-2 text-uppercase text-black bg-cs-color">
                      Maschinentyp
                    </span>
                    <select v-model="filters.produkttyp" id="produkttyp" name="produkttyp"
                      class="spanSelectField form-select form-select-lg mb-1">
                      <option value="Alle" selected>Alle</option>
                      <option value="Espressomaschine">Espressomaschine</option>
                      <option value="Filterkaffeemaschine">Filterkaffeemaschine</option>
                      <option value="Pad-Kaffeemaschine">Pad-Kaffeemaschine</option>
                      <option value="Pod-Kaffeemaschine">Pod-Kaffeemaschine</option>
                      <option value="Vakuum-Kaffeemaschine">Vakuum-Kaffeemaschine</option>
                    </select>
                  </div>

                  <div class="ml-2 mb-3 w-[80%]">
                    <span
                      class="spanField small fw-semibold d-inline-block mt-1 py-1 px-2 text-uppercase text-black bg-cs-color ">
                      Einfüllart
                    </span>
                    <select v-model="filters.kaffee_einfuellart" id="kaffee_einfuellart" name="kaffee_einfuellart"
                      class="spanSelectField form-select form-select-lg mb-1">
                      <option value="Alle" selected>Egal</option>
                      <option value="Kaffeebohnen">Ganze Bohnen</option>
                      <option value="Gemahlener Kaffee">Gemahlenes Pulver</option>
                      <option value="Kaffeekapsel">Kapseln</option>
                      <option value="Kaffeepad">Pads</option>
                      <option value="Kaffeebohnen, Gemahlener Kaffee">Kaffeebohnen & gemahlene Kaffeebohnen</option>
                      <option value="Kaffeepad, Gemahlener Kaffee">Kaffeepad & gemahlene Kaffeebohnen</option>
                    </select>
                  </div>

                  <div class="ml-2 mb-3 w-[80%]">
                    <span class="spanField small fw-semibold d-inline-block mt-1 py-1 px-2 text-uppercase text-black bg-cs-color">
                      Wassertank (Liter)
                    </span>
                    <select 
                      v-model="filters.fassungsvermoegen_wassertank" 
                      id="fassungsvermoegen_wassertank" 
                      name="fassungsvermoegen_wassertank"
                      class="spanSelectField form-select form-select-lg mb-1"
                    >
                      <option value="Alle">Alle</option>

                      <option value="1.0">Kompakt (bis 1,0 Liter)</option>
                      <option value="1.1">Standard (ab 1,1 Liter)</option>
                      <option value="1.8">Groß / Familie (ab 1,8 Liter)</option>
                      <option value="2.5">Maximal / Büro (ab 2,5 Liter)</option>
                    </select>
                  </div>

                  <div class="ml-2 mb-3 w-[80%]">
                    <span
                      class="spanField small fw-semibold d-inline-block mt-1 py-1 px-2 text-uppercase text-black bg-cs-color ">
                      Milchsystem
                    </span>
                    <select v-model="filters.art_milchzugabe" id="art_milchzugabe" name="art_milchzugabe"
                      class="spanSelectField form-select form-select-lg mb-1">
                      <option value="Alle" selected>Alle</option>
                      <option value="Automatisch">Integriert / Automatisch</option>
                    </select>
                  </div>

                </div>

                <h5>Preis</h5>
                <div class="mt-5 mb-5" id="slider"></div>
                <input type="text" id="minCost" readonly hidden>
                <input type="text" id="maxCost" readonly hidden>

                <div class="mt-3">
                  <details open>
                    <summary>Weitere Eigenschaften</summary>
                    <div class="container">
                      <div class="row row-cols-2">
                        <div class="col-md-6 d-flex mb-4">
                          <div class="form-check form-switch d-flex">
                            <input class="form-check-input me-2" type="checkbox" id="eingebautes_mahlwerk"
                              v-model="filters.eingebautes_mahlwerk" value="1" true-value="1" false-value="0">
                            <label class="form-check-label" for="eingebautes_mahlwerk">Integriertes Mahlwerk</label>
                          </div>
                        </div>

                        <div class="col-md-6 d-flex mb-4">
                          <div class="form-check form-switch d-flex">
                            <input class="form-check-input me-2" type="checkbox" id="zwei_tassen_auf_einmal"
                              v-model="filters.zwei_tassen_auf_einmal" value="1" true-value="1" false-value="0">
                            <label class="form-check-label" for="zwei_tassen_auf_einmal">Zwei Tassen
                              gleichzeitig</label>
                          </div>
                        </div>

                        <div class="col-md-6 d-flex mb-4">
                          <div class="form-check form-switch d-flex">
                            <input class="form-check-input me-2" type="checkbox" id="integrierter_milchaufschaeumer"
                              v-model="filters.integrierter_milchaufschaeumer" value="1" true-value="1" false-value="0">
                            <label class="form-check-label" for="integrierter_milchaufschaeumer">Integrierter
                              Milchaufschäumer</label>
                          </div>
                        </div>

                        <div class="col-md-6 d-flex mb-4">
                          <div class="form-check form-switch d-flex">
                            <input class="form-check-input me-2" type="checkbox" id="einstellbare_kaffeestaerke"
                              v-model="filters.einstellbare_kaffeestaerke" value="1" true-value="1" false-value="0">
                            <label class="form-check-label" for="einstellbare_kaffeestaerke">Einstellbare Stärke</label>
                          </div>
                        </div>

                        <div class="col-md-6 d-flex mb-4">
                          <div class="form-check form-switch d-flex">
                            <input class="form-check-input me-2" type="checkbox" id="eingebautes_display"
                              v-model="filters.eingebautes_display" value="1" true-value="1" false-value="0">
                            <label class="form-check-label" for="eingebautes_display">Display</label>
                          </div>
                        </div>

                        <div class="col-md-6 d-flex mb-4">
                          <div class="form-check form-switch d-flex">
                            <input class="form-check-input me-2" type="checkbox" id="heisswassersystem"
                              v-model="filters.heisswassersystem" value="1" true-value="1" false-value="0">
                            <label class="form-check-label" for="heisswassersystem">Heißwasserfunktion (Tee)</label>
                          </div>
                        </div>

                        <div class="col-md-6 d-flex mb-4">
                          <div class="form-check form-switch d-flex">
                            <input class="form-check-input me-2" type="checkbox" id="wlan" v-model="filters.wlan"
                              value="1" true-value="1" false-value="0">
                            <label class="form-check-label" for="wlan">WLAN / App-Steuerung</label>
                          </div>
                        </div>

                        <div class="col-md-6 d-flex mb-4">
                          <div class="form-check form-switch d-flex">
                            <input class="form-check-input me-2" type="checkbox" id="wasserfilter"
                              v-model="filters.wasserfilter" value="1" true-value="1" false-value="0">
                            <label class="form-check-label" for="wasserfilter">Wasserfilter inkl.</label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </details>
                </div>

                <div class="form-footer mt-2">
                  <button type="reset" class="btn btn-secondary btn-sm px-4 py-2">Auswahl zurücksetzen</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>

      <div class="col-12 col-md-9 col-lg-9 col-xl-8">
        <div v-if="loading" class="loading-spinner"></div>
        <div v-else class="pt-4">

          <div class="row g-4">
            <div v-for="(product, index) in products" :key="product.id" class="col-12 col-sm-6 col-lg-4 mb-4"
              :class="getCardAnimationClass(index)">
              <div class="card" :class="{ 'is-flipped': isFlipped(index) }">

                <div class="card-front">
                  <h5 class="card-title text-center mt-3 mx-5">
                    {{ product.amazonNamenSuche }}
                  </h5>
                  <pic-carousel :product="product" />
                  <div class="card-body">
                    <div class="row">

<div class="col-12 col-sm-6">
  <div class="d-flex flex-column">
    <span class="label-data-front mx-2">Zubereitungstyp</span> 

    <span class="ml-2" v-if="product.kaffeezubereitungstyp">
      {{ product.kaffeezubereitungstyp }}
    </span>
    <span class="ml-2" v-else>keine Angabe</span>

    <span class="label-data-front mx-2">Kaffeestärke</span> 

    <span class="ml-2" v-if="product.einstellbare_kaffeestaerke == 1">
      Ja, ist einstellbar
    </span>
    <span class="ml-2" v-else-if="product.einstellbare_kaffeestaerke == 2">
      Nicht einstellbar
    </span>
    <span class="ml-2" v-else>
      Keine Angabe
    </span>

  </div>
</div>

                      <div class="col-12 col-sm-6">
                        <div class="d-flex flex-column">
                          <span class="label-data-front mx-2">Einfüllart</span>
                          <span class="ml-2" v-if="product.kaffee_einfuellart">
                            {{product.kaffee_einfuellart }}</span>
                          <span class="ml-2" v-else>keine Angabe</span>

                          <span class="label-data-front mx-2">Wassertank</span>
                          <span class="ml-2" v-if="product.fassungsvermoegen_wassertank">
                            {{product.fassungsvermoegen_wassertank }} l</span>
                          <span class="ml-2" v-else>keine Angabe</span>

                          
                        </div>
                      </div>

                    </div>
                  </div>
                  <button class="datasheet-button" @click="flipCard(index)">
                    <i class="fa-solid fa-rotate-right icon-margin-right"></i>
                    Daten aufklappen
                  </button>
                  <div class="card-footer">
                    <div class="footer-content d-flex justify-content-between">
                      <div class="shop-info">
                        <span class="no_click" style='text-align: left;'>Amazon.de</span>
                        <div class="text-muted small" style='text-align: left; font-size: 12px;'>
                          aktualisiert: {{ product.updated_time }}
                        </div>
                      </div>
                      <div class="amazon-info">
                        <div class="pb-2">
                          <div class="no_click pb-1" style="text-align:left;">
                            <img class="shop-icon" src="/wp-content/plugins/tv-finder/amazon_icon.png" alt="Amazon Logo"
                              style="margin-right: 4px;" />
                            <span class="mr-2">| </span>
                            <span class="price">{{ Number(String(product.preisAmazonNeu).replace(',', '.'))
                              .toLocaleString('de-DE', { style: 'currency', currency: 'EUR' }) }}</span><br />
                            <a :href="product.amazon_url" rel="sponsored nofollow noopener" target="_blank">
                              <button class="btn12 px-3 py-1">zum Angebot*</button>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="card-back">
                  <div class="card-body">
                    <DatenblattMod :product="product" />
                  </div>
                  <button class="datasheet-button" @click="flipCard(index)">
                    <i class="fa-solid fa-rotate-left icon-margin-right"></i>
                    Zurück zur Übersicht
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="text-center">
        <button class="datasheet-button" @click="updateTv">
          Mehr Kaffeemaschinen laden
        </button>
      </div>
    </div>

  </div>
</template>

<script>
import PicCarousel from "./PicCarousel.vue";
import DatenblattMod from "./DatenblattMod.vue";

export default {

  components: {
    PicCarousel,
    DatenblattMod,
  },
  name: 'KaffeemaschinenFinderApp',
  props: {

  },

  data() {
    return {
      flippedCards: [],
      products: [],
      loading: false,
      loadedProducts: [],
      productsPerLoad: 9,
      loadedProductIndex: 9,

      filters: {
        marke: 'Alle',
        kaffeezubereitungstyp: 'Alle',
        produkttyp: 'Alle',
        kaffee_einfuellart: 'Alle',
        art_milchzugabe: 'Alle',
        minPrice: '30',
        maxPrice: '3000',
        minDruck: '0',
        maxDruck: '20',
        fassungsvermoegen_wassertank: 'Alle',

        eingebautes_mahlwerk: '0',
        zwei_tassen_auf_einmal: '0',
        integrierter_milchaufschaeumer: '0',
        einstellbare_kaffeestaerke: '0',
        eingebautes_display: '0',
        heisswassersystem: '0',
        wlan: '0',
        wasserfilter: '0'
      },
      ui: { navOpen: false },
    };
  },
  methods: {

    handleDocClick(e) {
      const root = this.$refs.navRoot;
      if (root && !root.contains(e.target)) this.ui.navOpen = false;
    },

initializeSlider() {
      var slider = document.getElementById('slider');
      noUiSlider.create(slider, {
        connect: true,
        behaviour: 'tap',
        start: [this.filters.minPrice, this.filters.maxPrice],
        format: wNumb({
          decimals: 0,
          suffix: ' (€)',
        }),
        tooltips: true,
        range: {
          'min': [30, 10],       // Startet bei 30€, geht in 10€-Schritten weiter
          '60%': [600, 50],      // Bei 60% der Slider-Breite sind 600€ erreicht. Ab hier 50€-Schritte
          'max': [2500]          // Endet bei 2500€
        }
      });

      slider.noUiSlider.on('change', () => {
        this.filters.minPrice = parseInt(slider.noUiSlider.get()[0].replace(' (€)', ''));
        this.filters.maxPrice = parseInt(slider.noUiSlider.get()[1].replace(' (€)', ''));
        this.fetchProducts(this.filters);
      });

      var minCostInput = document.getElementById('minCost');
      var maxCostInput = document.getElementById('maxCost');

      minCostInput.addEventListener('change', () => {
        slider.noUiSlider.set([minCostInput.value.replace(' (€)', ''), null]);
      });

      maxCostInput.addEventListener('change', () => {
        slider.noUiSlider.set([null, maxCostInput.value.replace(' (€)', '')]);
      });

    },

    onFormChange() {
      this.fetchProducts(this.filters);
    },

    fetchProducts(filters) {
      this.loading = true;
      this.loadedProductIndex = 9;
      $.ajax({
        // Tausche die URL ggf. auf dein Kaffeemaschinen-PHP Skript aus
        url: '/wp-content/plugins/kaffeemaschinen-finder/testNeuFinderApp.php',
        method: 'POST',
        dataType: 'json',
        data: {
          filters: filters,
          limit: this.loadedProductIndex
        },
        success: (response) => {
          this.loading = false;
          this.products = response.filteredProducts;
        },
        error: (xhr, status, error) => {
        }
      });
    },

    flipCard(index) {
      const cardIndex = this.flippedCards.indexOf(index);
      if (cardIndex === -1) {
        this.flippedCards.push(index);
      } else {
        this.flippedCards.splice(cardIndex, 1);
      }
    },

    isFlipped(index) {
      return this.flippedCards.includes(index);
    },

    getCardAnimationClass(index) {
      const delay = (index + 1) * 25;
      return `animate__animated animate__fadeInUp animate__${delay}ms`;
    },

    updateTv() {
      this.loadedProductIndex += 9;
      $.ajax({
        // Tausche die URL ggf. auf dein Kaffeemaschinen-PHP Skript aus
        url: "/wp-content/plugins/kaffeemaschinen-finder/testNeuFinderApp.php",
        method: "POST",
        data: {
          filters: this.filters,
          limit: this.loadedProductIndex
        },
        dataType: "json",
        success: (response) => {
          this.products = response.filteredProducts;
        },
        error: (error) => {
        },
      });
    }
  },

  mounted() {
    this.initializeSlider();
    this.fetchProducts(this.filters);
    document.addEventListener("click", this.handleDocClick);
  },
  beforeUnmount() {
    document.removeEventListener("click", this.handleDocClick);


  }
};
</script>

<style scoped>
/* dezente Hover-Hilfe für die Optionsliste */
.hover-bg:hover {
  background: rgba(0, 0, 0, 0.04);
}

/* kleinere Close-Buttons in Chips (falls Bootstrap nicht vorhanden) */
.btn-close-sm {
  transform: scale(0.8);
}

h3 {
  margin: 40px 0 0;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

.form-check-input[type="checkbox"].form-check-input {
  width: 40px;
  height: 20px;
}

.form-check-input[type="checkbox"].form-check-input {
  margin-right: 10px;
  padding: 5px;
}

.bg-cs-color {
  background-color: #b9d1ff;
}

.spanField {
  border-radius: 10px 10px 0 0;
}

.spanSelectField {
  border-radius: 0 10px 10px 10px;
  border-width: 1px;
  border-color: #DDD1C5
}

.spanSelectField:focus {
  outline: none;
  border-color: #c2ab9282;
  box-shadow: 0 0 5px #c2ab9282;
}

.flip-card-3D-wrapper {
  perspective: 1000px;
}

.card {
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  margin: 5px;
  text-align: center;
  transform-style: preserve-3d;
  transition: transform 0.5s;
  display: flex;
}

.card.is-flipped {
  transform: rotateY(180deg);
}

.card-front,
.card-back {
  width: 100%;
  height: 100%;
  backface-visibility: hidden;
}

.card-back {

  transform: rotateY(180deg);
  position: absolute;
}

.label-data-front {
  color: #999
}

@media (min-width: 992px) {
  .custom-width-desktop {
    width: 25%;
  }
}

.scrolly {
  max-height: 900;
  overflow-y: auto;
  border: 1px solid #ccc;
}

.icon-margin-right {
  margin-right: 8px;

}

.loading-spinner {
  border: 16px solid #f3f3f3;
  border-top: 16px solid #c2ab9282;
  border-radius: 50%;
  width: 120px;
  height: 120px;
  animation: spin 2s linear infinite;
  margin: auto;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.shop-info {
  text-align: left;
}

.scrollable-div::-webkit-scrollbar-track {
  background-color: #f1f1f1;
}


.scrollable-div::-webkit-scrollbar-thumb {
  background-color: #888;
  border-radius: 10px;
  border: 3px solid #f1f1f1;
}


.scrollable-div::-webkit-scrollbar {
  width: 12px;
}

.scrollable-div {
  scrollbar-width: thin;
  scrollbar-color: #888 #f1f1f1;
}

.scrollable-container {
  height: auto !important;
  overflow-y: visible;
  position: static;
}

@media (min-width: 992px) {
  .scrollable-container {
    overflow-y: auto;
    position: sticky;
    top: 0px;
  }
}

.btn12 {
  background-color: #fa890052;
  border: 1px solid #222 !important;
}



#slider,
#druck-slider {
  width: clamp(260px, 90%, 520px);
  margin-inline: auto;
  display: block;
  padding-inline: 12px;
  box-sizing: border-box;
}
</style>